import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PaiementService {

  private DOMAINE_URL = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('authToken'); // Replace with your token retrieval logic
    return new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
  }

  getPaidPayments(idStudent: number, idOrg: number): Observable<any> {
    return this.http.get(`${this.DOMAINE_URL}/paiement/listPaiementStudentStatus/${idStudent}/${idOrg}/1/`, {
      headers: this.getAuthHeaders()
    }).pipe(
      tap(response => console.log('Paid Payments Response:', response))
    );
  }

  getNotPaidPayments(idStudent: number, idOrg: number): Observable<any> {
    return this.http.get(`${this.DOMAINE_URL}/paiement/listPaiementStudentStatus/${idStudent}/${idOrg}/0/`, {
      headers: this.getAuthHeaders()
    }).pipe(
      tap(response => console.log('Unpaid Payments Response:', response))
    );
  }

  getRecuPaiement(idStudent: number, idOrg: number, numberPage: number, sizePage: number): Observable<any> {
    // New API: listRecuPaiementDetails returns detailed receipt entries
    return this.http.get(`${this.DOMAINE_URL}/paiement/listRecuPaiementDetails/${idStudent}/${idOrg}/${numberPage}/${sizePage}/`, {
      headers: this.getAuthHeaders()
    }).pipe(
      tap(response => console.log('Receipt Payments Details Response:', response))
    );
  }

  uploadPaymentFile(formData: FormData) {
    return this.http.post<{ fileName: string }>(
      `${this.DOMAINE_URL}/paiements/upload`,
      formData,
      { headers: this.getAuthHeaders() }
    );
  }

  downloadPaymentFile(filePath: string, filename: string): Observable<Blob> {
    const url = `${this.DOMAINE_URL}/mobile/files/download?path=${encodeURIComponent(filePath)}&filename=${encodeURIComponent(filename)}`;
    return this.http.get(url, { responseType: 'blob', headers: this.getAuthHeaders() });
  }

  handleError(error: any): void {
    console.error('An error occurred:', error);
    if (error.status === 403) {
      console.error('Access forbidden: Check your authentication token or permissions.');
    } else if (error.status === 0) {
      console.error('Network error: Check your connection or CORS settings.');
    }
  }

}
